import { render } from "./ModalJira.vue?vue&type=template&id=124b2d9f&scoped=true&ts=true"
import script from "./ModalJira.vue?vue&type=script&lang=ts"
export * from "./ModalJira.vue?vue&type=script&lang=ts"

import "./ModalJira.vue?vue&type=style&index=0&id=124b2d9f&scoped=true&lang=css"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-124b2d9f"]])

export default __exports__